// extracted by mini-css-extract-plugin
export default {"ResourcesFilters":"ResourcesFilters_ResourcesFilters__JHH1+"};